import React from 'react'
import PropTypes from 'prop-types'
import { Avatar, Box, Clickable, Text } from '@maui/elements'

export default function Request({ data, showServiceDetail, loading }) {
  const { contact_name: contactName = 'None', service_requested: serviceRequested, status, created_at: date, description = '' } = data
  const includesMandiant = contactName?.includes('Mandiant')
  const avatarStr = includesMandiant ? 'M' : contactName
  const shortDescription = description?.length > 100 ? description.substring(0, 100) + '...' : description
  return (
    <Clickable pb='spaceGapLarge' color='colorTextMain' borderBottom='1px solid' borderColor='colorBorderMain' onClick={() => showServiceDetail(data)} _hover={{ backgroundColor: 'colorFillDeemphasis' }} disabled={loading}>
      <Box display='flex' mt='spaceGapLarge'>
        <Box width='30px'>
          <Avatar
            color='colorTextMain'
            backgroundColor={includesMandiant ? 'colorBrandingMandiantRed' : 'colorFillMain'}
            fontSize='12px'
            size='24px'
          >
            {avatarStr}
          </Avatar>
        </Box>
        <Box flex='1' paddingTop='spaceGapSmall'>
          <Box marginBottom='spaceGapMedium' display='flex' flexDirection='row' width='100%' justifyContent='space-between'>
            <Box>
              <Text
                as='span'
                variant='body1'
                fontWeight='fontWeightBold'
              >Ask An Expert</Text>
              <Text
                as='span'
                variant='body2'
              > - {serviceRequested}</Text>
            </Box>
            <Text variant='body2' fontWeight='fontWeightBold' fontSize='10px'>{status}</Text>
          </Box>
          <Text
            as='span'
            variant='body2'
            color='colorTextDeemphasis'
            mb='spaceGapSmall'
          >{date}</Text>
          <Text variant='body2' title={description} color='colorTextDeemphasis'>{shortDescription}</Text>
        </Box>
      </Box>
    </Clickable>
  )
}

Request.propTypes = {
  showServiceDetail: PropTypes.func,
  data: PropTypes.object,
  loading: PropTypes.bool
}
